<template>
    <div class="container mat40 changelog-page">
        <div class="changelog-page__header">
            <div class="changelog-page__intro">
                <h1>Lista zmian w systemie Dostartu (changelog)</h1>
                <p>
                    Śledź na bieżąco aktualizacje platformy DO:ST:AR:TU. Wdrażamy usprawnienia,
                    naprawiamy błędy i dbamy o najwyższą wydajność systemu obsługi zgłoszeń.
                </p>
            </div>
            <div
                v-if="lastUpdate"
                class="changelog-page__stats"
            >
                <span>Ostatnia aktualizacja:</span>
                <strong>{{ lastUpdate }}</strong>
            </div>
        </div>
        <div
            v-if="!ready"
            class="mat32"
        >
            <div class="admin-header__loading-state">
                Trwa wczytywanie
                <div class="mal15 lds-ellipsis">
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        </div>
        <div
            v-else-if="entries.length === 0"
            class="changelog-page__empty"
        >
            Brak opublikowanych zmian.
        </div>
        <div
            v-else
            class="changelog-page__list"
        >
            <changelog-entry-item
                v-for="(entry, index) in entries"
                :key="entry.id"
                :entry="entry"
                variant="dark"
                :is-first="index === 0"
                :is-last="index === entries.length - 1"
            />
        </div>
    </div>
</template>

<script>
import { listChangelog } from '@/api/changelog';
import { formatReleasedAt, markSeen } from '@/utils/changelogStorage';
import ChangelogEntryItem from '@/components/ChangelogEntryItem';

export default {
    name: 'PanelChangelog',
    components: {
        ChangelogEntryItem,
    },
    data() {
        return {
            ready: false,
            entries: [],
        };
    },
    computed: {
        lastUpdate() {
            return formatReleasedAt(this.entries[0] && this.entries[0].releasedAt);
        },
    },
    async created() {
        try {
            const data = await listChangelog();
            this.entries = Array.isArray(data) ? data : [];

            if (this.entries[0] && this.entries[0].id != null) {
                markSeen(this.entries[0].id);
            }
        } catch (error) {
            this.entries = [];
        } finally {
            this.ready = true;
        }
    },
};
</script>

<style scoped>
.changelog-page__header {
    display: flex;
    gap: 24px;
    align-items: center;
    margin-bottom: 40px;
}

.changelog-page__intro {
    flex: 1;
    min-width: 0;
}

.changelog-page__intro h1 {
    margin: 0 0 8px;
    font-size: 24px;
    line-height: normal;
    color: var(--color-silver);
}

.changelog-page__intro p {
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: var(--color-cool-grey);
}

.changelog-page__stats {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: var(--color-slate);
    border-radius: 4px;
    font-size: 13px;
    line-height: normal;
    white-space: nowrap;
}

.changelog-page__stats span {
    font-weight: 600;
    color: var(--color-silver);
}

.changelog-page__stats strong {
    font-weight: 700;
    color: var(--color-white);
}

.admin-header__loading-state {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.changelog-page__empty {
    padding: 24px 0;
    color: var(--color-cool-grey);
}

.changelog-page__list {
    display: flex;
    flex-direction: column;
}

@media (max-width: 991px) {
    .changelog-page__header {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 24px;
    }

    .changelog-page__intro h1 {
        font-size: 18px;
        line-height: 24px;
        color: var(--color-white);
    }

    .changelog-page__stats {
        display: none;
    }
}
</style>
